import React from 'react';
import { isEmptyText } from './isEmptyText';
import { LinkType, Prismic, PrismicText } from './Prismic';

export function getDataFromLink(el?: Prismic.Link) {
  if (!el)
    return {
      title: null,
      abstract: null,
      image: null,
    };

  const docLink = el._linkType === LinkType.Document ? el : undefined;

  if (docLink) {
    const title = docLink.page_title || docLink.title;
    const abstract = docLink.abstract;
    const image = docLink.abstract_image || docLink.image;

    return {
      title,
      abstract,
      image,
    };
  }

  return {
    title: null,
    abstract: null,
    image: null,
  };
}

function fallbackTextRaw(
  firstEl: Prismic.RichText,
  secondEl?: Prismic.RichText,
  thirdEl?: Prismic.RichText,
) {
  return !isEmptyText(firstEl)
    ? firstEl
    : secondEl && !isEmptyText(secondEl)
    ? secondEl
    : thirdEl && !isEmptyText(thirdEl)
    ? thirdEl
    : null;
}

export function fallbackText(
  firstEl: Prismic.RichText,
  secondEl?: Prismic.RichText,
  thirdEl?: Prismic.RichText,
) {
  return Prismic.text(fallbackTextRaw(firstEl, secondEl, thirdEl));
}

export function fallbackRichText(
  firstEl: Prismic.RichText,
  secondEl?: Prismic.RichText,
  thirdEl?: Prismic.RichText,
) {
  if (!fallbackTextRaw(firstEl, secondEl, thirdEl)) {
    return null;
  }
  return (
    <PrismicText
      value={fallbackTextRaw(firstEl, secondEl, thirdEl) ?? undefined}
    />
  );
}

export function fallbackImage(
  firstEl: Prismic.Image,
  secondEl?: Prismic.Image,
  thirdEl?: Prismic.Image,
) {
  return firstEl || secondEl || thirdEl || null;
}
